var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.135,
    height: 18.965,
    viewBox: "0 0 20.135 18.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-203.998 -244.863)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.674 249.475)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.493)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.741,
    cy: 3.742,
    rx: 3.741,
    ry: 3.742,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.741,
    cy: 3.742,
    rx: 2.741,
    ry: 2.742,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.185 14.217) rotate(180)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.182,0A6.591,6.591,0,0,1,6.591,6.591,6.591,6.591,0,0,1,0,0C-.021.012,13.143.067,13.182,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.467026710510254 2.016592502593994 C 3.21490478515625 3.54007887840271 4.782459259033203 4.591120719909668 6.590969085693359 4.591120719909668 C 8.393613815307617 4.591120719909668 9.956966400146484 3.546678304672241 10.70771598815918 2.031200885772705 C 10.25314617156982 2.032265186309814 9.739462852478027 2.032800674438477 9.169488906860352 2.032800674438477 C 7.471068859100342 2.032800674438477 5.269478797912598 2.027900695800781 3.129239082336426 2.019371032714844 C 2.900206565856934 2.018457412719727 2.678884506225586 2.01752758026123 2.467026710510254 2.016592502593994 M 2.86102294921875e-05 9.5367431640625e-07 C -3.814697265625e-06 4.100799560546875e-05 -4.76837158203125e-06 2.050399780273438e-05 2.86102294921875e-05 9.5367431640625e-07 Z M 13.18191909790039 9.5367431640625e-07 C 13.18191909790039 3.640170812606812 10.23104858398438 6.591120719909668 6.590969085693359 6.591120719909668 C 2.950888633728027 6.591120719909668 2.86102294921875e-05 3.640170812606812 2.86102294921875e-05 9.5367431640625e-07 C 0.01295375823974609 0.007959365844726563 5.296441078186035 0.03279924392700195 9.169489860534668 0.03279924392700195 C 11.40356826782227 0.03279924392700195 13.16775131225586 0.02454090118408203 13.18191909790039 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-23168.885-22289.941v-16.965h18.135v16.965",
    transform: "translate(23373.883 22552.77)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconWhite);
export default __webpack_public_path__ + "static/media/profileIconWhite.0410e0ead300ebc96bbce580bf83e916.svg";
export { ForwardRef as ReactComponent };